import React, { useState } from "react";

const DownloadXlsxButton = ({ onExport, label = "Exportar a XLSX", disabled = false }) => {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    if (busy || disabled) return;
    try {
      setBusy(true);
      await onExport?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={busy || disabled}
      className={`py-2 px-4 w-fit rounded-md text-sm font-medium 
        ${busy || disabled ? "opacity-60 cursor-not-allowed" : "bg-green-600 text-white hover:bg-green-700"}`}
      title="Descargar datos filtrados en XLSX"
    >
      {busy ? "Generando..." : label}
    </button>
  );
};

export default DownloadXlsxButton;
